import { Table, TableBody, TableHeader, TableRow } from '../styles';
import { ColumnData, TableData } from '../types';

export interface TableProps {
  data: TableData[];
  columns: ColumnData[];
}

export const TableDesktop = ({ data, columns }: TableProps) => (
  <Table className="caption-regular">
    <thead>
      <TableHeader>
        {columns.map((column) => (
          <th key={column.id}>{column.label}</th>
        ))}
      </TableHeader>
    </thead>
    <TableBody>
      {data.map((row) => (
        <TableRow key={row.printer}>
          {columns.map((column) => (
            <td key={column.id}>{row[column.id as keyof typeof row]}</td>
          ))}
        </TableRow>
      ))}
    </TableBody>
  </Table>
);
